import {StyleSheet} from 'react-native';

export const DownloadButtonStyle = StyleSheet.create({
  root: {
    minWidth: 24,
    minHeight: 24,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
});
